import { render, staticRenderFns } from "./CardTarjaOlimpiadasSporTV.vue?vue&type=template&id=5030a24a&scoped=true"
import script from "./CardTarjaOlimpiadasSporTV.vue?vue&type=script&lang=js"
export * from "./CardTarjaOlimpiadasSporTV.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaOlimpiadasSporTV.vue?vue&type=style&index=0&id=5030a24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030a24a",
  null
  
)

export default component.exports